import React from 'react'
import { Col, Container, Row } from 'reactstrap'
import { P } from '../../AbstractElements'
import { Globe } from 'react-feather'
import FooterLanguage from './FooterLanguage'

export default function FooterLayout() {
    const currentYear = new Date().getFullYear();
    return (
        <footer className="footer">
       <Container
  fluid
  style={{
    backgroundColor: "#f8f9fa",      // light neutral background
    borderTop: "1px solid #e0e0e0", // subtle divider
    padding: "6px 12px",            // tighter padding
  }}
>
  <Row className="align-items-center">
    <Col
      lg={6}
      md={7}
      className="footer-copyright"
      style={{ textAlign: "left" }}
    >
      <p
        style={{
          margin: 0,
          fontSize: "0.75rem",        // smaller font
          color: "#6c757d",           // muted text color
          fontWeight: 400,
          letterSpacing: "0.3px",
        }}
      >
        © {currentYear} Acers. All rights reserved.
      </p>
    </Col>

    <Col
      lg={6}
      md={5}
      style={{
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        gap: "12px",
      }}
    >
    
    </Col>
  </Row>
</Container>

        </footer>
    )
}
